<template>
    <div class="content">
        <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <div class="custom-toolbar md-layout">
                    <div class="md-layout-item custom-toolbar-start md-layout md-small-size-80 md-size-90">
                        <team-members-filter @onSelection="onTeamMemberSelection" />

                        <div class="md-layout-item">
                            <date-range-filter :is-single-date="true" @onChanged="onDateChanged" />
                        </div>
                    </div>
                    <div class="md-layout-item custom-toolbar-end">
                        <md-button
                            title="Export Location History report"
                            class="md-primary md-just-icon md-round pull-right header-button"
                            @click="onExportToExcel"
                        >
                            <md-icon>get_app</md-icon>
                        </md-button>
                    </div>
                </div>
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>summarize</md-icon>
                        </div>
                    </md-card-header>

                    <md-card-content>
                        <div v-if="!locationHistoryList || locationHistoryList.length == 0">
                            <h3>Location History Report</h3>
                            <p>
                                No results to display.
                            </p>
                        </div>
                        <div v-else>
                            <div class="report-container">
                                <location-history-report-details :member-list="locationHistoryList" />
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            </div>
        </div>
    </div>
</template>
<style scoped>
.header-button {
    width: 32px;
    height: 32px;
    min-width: 32px;
}

.alert-z {
    z-index: 0 !important;
}
</style>
<script>
import moment from 'moment';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { mapMutations, mapGetters } from 'vuex';
import LocationHistoryReportDetails from './LocationHistoryReportDetails';
import { handleRequests, downloadFile } from '../../helpers';
import { TeamMembersFilter, DateRangeFilter } from './components';

export default {
    name: 'LocationHistoryReport',
    components: { LocationHistoryReportDetails, TeamMembersFilter, DateRangeFilter },
    mixins: [GeneralMixin],
    data() {
        return {
            isLoading: true,
            reportDate: null,
            locationHistoryList: [],
            userFullName: '',
            selectedTeamMember: {},
            smallAlertModalHide: false
        };
    },
    methods: {
        ...mapGetters({
            user: 'user/user'
        }),
        ...mapMutations({
            changeDate: 'map/CHANGE_DATE'
        }),

        onExportToExcel() {
            const reportDate = moment(this.reportDate).format('YYYY-MM-DD');
            if (this.reportDate) {
                this.$_handleLoaderState(true);
                const api = `/api/reports/location-history/${reportDate}/export-to-excel?userId=${this
                    .selectedTeamMember.userId || ''}&isTracker=${this.selectedTeamMember.isTracker}`;
                const payload = {
                    method: 'get',
                    responseType: 'blob'
                };
                const reportName = `${this.selectedTeamMember.name ||
                    this.userFullName}-LocationHistory-${reportDate}.xlsx`;
                handleRequests(api, payload)
                    .then((response) => {
                        downloadFile(response.data, reportName);
                        this.$_handleLoaderState(false);
                    })
                    .catch((e) => {
                        this.$_handleLoaderState(false);
                        this.$notify({ message: e.data, type: 'danger' });
                    });
            }
        },

        getLocationHistoryList() {
            this.isLoading = true;
            if (this.reportDate) {
                this.$_handleLoaderState(true);
                const api = `/api/reports/location-history/${moment(this.reportDate).format('YYYY-MM-DD')}?userId=${this
                    .selectedTeamMember.userId || ''}&isTracker=${this.selectedTeamMember.isTracker}`;
                handleRequests(api)
                    .then((response) => {
                        this.isLoading = false;

                        const { data } = response.data;
                        this.locationHistoryList = data;
                        this.$_handleLoaderState(false);
                    })
                    .catch((e) => {
                        this.locationHistoryList = [];
                        this.$_handleLoaderState(false);
                        this.$notify({ message: e.data, type: 'danger' });
                    });
            }
        },

        async onDateChanged(val) {
            this.reportDate = val;
            this.getLocationHistoryList();
        },

        async onTeamMemberSelection(val) {
            this.selectedTeamMember = val || {};
            this.getLocationHistoryList();
        }
    },
    async mounted() {
        this.userFullName = this.user().fullName;
    }
};
</script>
